import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-date-divider',
    templateUrl: './date-divider.component.html',
    styleUrls: ['./date-divider.component.css'],
    imports: [DatePipe]
})
export class DateDividerComponent implements OnInit {
  @Input() Date;
  constructor() { }

  ngOnInit() {
    //console.log(this.Date);
  }

}
